import { useState } from "react";
import { MathShell, Field, ResultCard, MATH_ACCENT } from "./MathShell.jsx";
import { trigNumeric, trigExact, round, EXACT } from "./mathcore.js";
import QuizMode from "../components/QuizMode.jsx";

const COMMON = [0, 30, 45, 60, 90, 120, 135, 150, 180, 210, 225, 240, 270, 300, 315, 330];

export default function Trig() {
  const [deg, setDeg] = useState("45");
  const [quiz, setQuiz] = useState(false);
  const d = parseFloat(deg);
  const valid = !isNaN(d);
  const num = valid ? trigNumeric(d) : null;
  const exact = valid ? trigExact(d) : null;

  // Curated recall over the exact unit-circle values already in this
  // tool. Prompt = "sin 45°", answer = exact value.
  const quizCards = Object.entries(EXACT).flatMap(([ang, v]) => [
    { q: `sin ${ang}°`, a: v.sin, ctx: "Unit circle" },
    { q: `cos ${ang}°`, a: v.cos, ctx: "Unit circle" },
    { q: `tan ${ang}°`, a: v.tan, ctx: "Unit circle" },
  ]);

  return (
    <MathShell title="Trig & Unit Circle">
      {quiz ? (
        <QuizMode cards={quizCards} accent={MATH_ACCENT} onExit={() => setQuiz(false)} />
      ) : (
      <>
      <button
        onClick={() => setQuiz(true)}
        style={{ width: "100%", marginBottom: 14, padding: 12, borderRadius: 10, border: `1px solid ${MATH_ACCENT}`, background: MATH_ACCENT + "18", color: MATH_ACCENT, fontWeight: 700, fontSize: 14, cursor: "pointer" }}
      >
        Quiz me on exact values →
      </button>
      <Field label="Angle (degrees)" value={deg} onChange={(e) => setDeg(e.target.value)} inputMode="decimal" />
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 6 }}>
        {COMMON.map((a) => (
          <button key={a} onClick={() => setDeg(String(a))} style={{ background: "#1C1E2E", color: "#9A9DBE", border: "none", borderRadius: 8, padding: "6px 10px", fontSize: 13, cursor: "pointer" }}>
            {a}°
          </button>
        ))}
      </div>
      {valid && (
        <ResultCard>
          <Row label="Radians" v={`${round(num.rad, 6)}`} />
          <Row label="sin" v={`${round(num.sin, 6)}`} exact={exact?.sin} />
          <Row label="cos" v={`${round(num.cos, 6)}`} exact={exact?.cos} />
          <Row label="tan" v={num.tan === null ? "undefined" : `${round(num.tan, 6)}`} exact={exact?.tan} />
        </ResultCard>
      )}
      {!valid && <ResultCard><span style={{ color: "#F8716A" }}>Enter a numeric angle</span></ResultCard>}
      </>
      )}
    </MathShell>
  );
}

function Row({ label, v, exact }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", padding: "8px 0", borderBottom: "1px solid #1C1E2E" }}>
      <span style={{ color: "#9A9DBE", fontSize: 14 }}>{label}</span>
      <span style={{ textAlign: "right" }}>
        {exact && <span style={{ color: MATH_ACCENT, fontWeight: 600, marginRight: 10 }}>{exact}</span>}
        <span style={{ color: "#C8CADF", fontSize: 14 }}>{v}</span>
      </span>
    </div>
  );
}

